import * as React from 'react';

import { dispatch } from 'old/store';
import { PostRendererCore, EventRendererCore, CampaignRendererCore } from '../../atoms/feed-object';
import PollRendererCore from '../../../features/polls/PollRendererCore';
import { can } from '../../utils/permissions';

export class ShareContentObjectRenderer extends React.Component {
  componentDidMount = async () => {
    const { item } = this.props;
    if (!item.post && !item.poll && !item.event && !item.campaign) {
      await dispatch.feed.findAsync({ postId: item.id });
    }
  };

  render() {
    const { item } = this.props;
    if (['post', 'kudo'].includes(item.type)) {
      return (
        <PostRendererCore
          item={item}
          viewer={this.props.viewer}
          onCreateObject={this.props.onCreateObject}
          onLikeObject={this.props.onLikeObject}
        />
      );
    } else if (item.type === 'poll') {
      const { viewer } = this.props;
      return (
        <PollRendererCore
          poll={{ ...item, ...item.poll }}
          isDisabled={item.author.id === viewer.id || viewer.superadmin}
          showChoicePercentage={
            item.author.id === viewer.id || can(item.post_in_communities, 'ContentObject', 'viewPollChoicePercentage')
          }
        />
      );
    } else if (item.type === 'event') {
      return (
        <EventRendererCore
          item={item}
          viewer={this.props.viewer}
          onCreateObject={this.props.onCreateObject}
          onLikeObject={this.props.onLikeObject}
          onRequestEventDetail={this.props.onRequestEventDetail}
        />
      );
    } else if (item.type === 'campaign' && item.campaign) {
      // item.campaign is undefined on first load
      return (
        <CampaignRendererCore
          item={item}
          viewer={this.props.viewer}
          onCreateObject={this.props.onCreateObject}
          onLikeObject={this.props.onLikeObject}
        />
      );
    } else {
      console.warn(`Cannot render shared content object of type '${item.type}'`);
      return null;
    }
  }
}
